import { render, staticRenderFns } from "./ShouninRouteSteps.vue?vue&type=template&id=fc4f8dba&scoped=true&"
import script from "./ShouninRouteSteps.vue?vue&type=script&lang=ts&"
export * from "./ShouninRouteSteps.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninRouteSteps.vue?vue&type=style&index=0&id=fc4f8dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4f8dba",
  null
  
)

export default component.exports